import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Slide from "@material-ui/core/Slide";
import MuiAlert from "@material-ui/lab/Alert";

import { makeStyles } from "@material-ui/core/styles";

function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
}

function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
}
function TransitionRight(props) {
    return <Slide {...props} direction="right" />;
}

function TransitionDown(props) {
    return <Slide {...props} direction="down" />;
}

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyle = makeStyles(() => ({
    snackbarContainer: {
        backgroundColor: "transparent",
        borderStyle: "none",
    },
}));

export default function SlideComponent(props) {
    const classes = useStyle();
    const slideTransition = {
        up: TransitionUp,
        down: TransitionDown,
        left: TransitionLeft,
        right: TransitionRight,
    };
    const [transition, setTransition] = React.useState(undefined);
    const vertical = props.vertical ? props.vertical : "top";
    const horizontal = props.horizontal ? props.horizontal : "right";

    React.useEffect(() => {
        setTransition(() => slideTransition[props.transition]);
    }, [props.transition]);

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={props.show}
                autoHideDuration={3000}
                ContentProps={{
                    className: classes.snackbarContainer,
                    elevation: 0,
                }}
                onClose={props.handleClose}
                TransitionComponent={transition}
                key={transition ? transition.name : ""}
                message={
                    <Alert severity={props.messageType}>{props.message}</Alert>
                }
            />
        </div>
    );
}
